/**
 * Created by iamso on 19.12.18.
 */

const LocalStorageDisabledWindow = CleverappsWindow.extend({ 
    onWindowLoaded: function () {
        const styles = cleverapps.styles.LocalStorageDisabledWindow;

        let content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);

        const addText = function (text) {
            text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
            text.setDimensions(cc.size(styles.width, 0));
            content.addChild(text);
        };

        // eslint-disable-next-line no-restricted-syntax
        addText(cleverapps.UI.generateTTFText(Messages.get("LocalStorageDisabledWindow.text2"), cleverapps.styles.FONTS.WINDOW_TEXT));
        // eslint-disable-next-line no-restricted-syntax
        addText(cleverapps.UI.generateTTFText(Messages.get("LocalStorageDisabledWindow.text1"), cleverapps.styles.FONTS.WINDOW_TEXT));

        cleverapps.UI.arrangeWithMargins(content.children, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
        cleverapps.UI.wrap(content);
        content = cleverapps.UI.wrapWithPadding(content, styles.padding);

        this.content = content;

        this._super({
            content,
            title: Messages.get("LocalStorageDisabledWindow.title"),
            name: "localstoragedisabledwindow",
            button: {
                text: Messages.get("OK"),
                width: styles.button.width
            },
            closeButton: false
        });
    }
});

cleverapps.styles.LocalStorageDisabledWindow = {
    width: 600,
    margin: 20,
    paddingY: 20,
    padding: {
        x: 0,
        top: 20,
        bottom: 50
    },

    button: {
        width: 200
    }
};